import { createContext } from 'react';
import { PreserveScrollContextType } from 'utils/types';

const PreserveScrollContext = createContext<PreserveScrollContextType>({
  itemId: '',
  isScrolled: false,
  updateItemId: () => {},
});

export default PreserveScrollContext;
